module.exports = new __parcel__URL__("lego.f7e59d26.png").toString();